const React = require("react");
const { useCJDropshipping } = require("../context/CJDropshippingContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;

const DropshippingImportedProducts = () => {
  const { t } = useCJDropshipping();
  return h(ProductCollectionPage, {
    imported: "true",
    title: t("h_cj_imported_title", "Imported products"),
    description: t("h_cj_imported_desc", "Products linked to your Elakay catalog and eligible for synchronization."),
  });
};
module.exports = { DropshippingImportedProducts };
